import React from 'react';


const programSections = [
    {
        title: "Процедуры", // Заголовок секции
        items: [ // Элементы внутри секции (процедуры)
            {
                title: "Массаж",
                description: "Различные виды массажа для оздоровления и релаксации. Способствует улучшению кровообращения и снятию мышечного напряжения.", // Placeholder описание
                imageUrl: "/Assets/Procedure/Massaj.jpg",
            },
            {
                title: "Спорт",
                description: "Занятия лечебной физкультурой, тренировки в спортзале, скандинавская ходьба под наблюдением специалистов.", // Placeholder описание
                imageUrl: "/Assets/Procedure/Sport.jpg", // Placeholder картинка
            },
            {
                title: "Озонотерапия",
                description: "Современные методики лечения с использованием озона. Применяется для улучшения общего состояния и борьбы с различными заболеваниями.", // Placeholder описание
                imageUrl: "/Assets/Procedure/Ozon.jpg", // Placeholder картинка
            },
            {
                title: "Карбокситерапия",
                description: "Подкожное введение углекислого газа для улучшения кровообращения и трофики тканей.", // Placeholder описание
                imageUrl: "/Assets/Procedure/Carbon.webp", // Placeholder картинка
            },
            {
                title: "Бальнеотерапия",
                description: "Водные процедуры с использованием минеральных вод, лечебных грязей и других природных факторов.", // Placeholder описание
                imageUrl: "/Assets/Procedure/Balneoterapiya.webp", // Placeholder картинка
            },
            {
                title: "Очищение кишечника",
                description: "Комплекс процедур для детоксикации организма и улучшения работы пищеварительной системы.", // Placeholder описание
                imageUrl: "/Assets/Procedure/chistka.webp", // Placeholder картинка
            },
            {
                title: "Физиотерапия",
                description: "Широкий спектр физиотерапевтических процедур для лечения и восстановления.", // Placeholder описание
                imageUrl: "/Assets/Procedure/fizio.webp", // Placeholder картинка
            },
        ]
    },
    {
        title: "Основные программы", // Заголовок секции
        items: [ // Элементы внутри секции (программы)
            {
                title: "Базовая",
                description: "Комплексная оздоровительная программа, направленная на общее укрепление организма.", // Placeholder описание
                imageUrl: "Assets/Programs/Base.jpg", // Placeholder картинка
            },
            {
                title: "Базовая премиум",
                description: "Расширенная версия базовой программы с дополнительными процедурами и услугами повышенного комфорта.", // Placeholder описание
                imageUrl: "Assets/Programs/Premium.png", // Placeholder картинка
            },
            {
                title: "Детокс",
                description: "Программа очищения организма от шлаков и токсинов, восстановление обмена веществ.", // Placeholder описание
                imageUrl: "Assets/Programs/Detoks.png", // Placeholder картинка
            },
            {
                title: "Крепкий иммунитет",
                description: "Программа для повышения защитных сил организма, профилактика простудных и инфекционных заболеваний.", // Placeholder описание
                imageUrl: "Assets/Programs/Immun.jpg", // Placeholder картинка
            }
        ]
    },

];


const TreatmentPage = () => {
    return (
        <div className="treatment-page-container"> {/* Контейнер страницы */}
            <header className="page-header">
                <h1>Программы Санатория "Родник"</h1> {/* Заголовок страницы */}
            </header>

            <div className="sections-wrapper"> {/* Обертка для секций */}
                {programSections.map((section, sectionIndex) => (
                    // Добавляем класс для первой секции, если нужно уникальное верхнее поле
                    <section className={`treatment-section ${sectionIndex === 0 ? 'first-section' : ''}`} key={sectionIndex}> {/* Секция Процедуры или Программы */}
                        <h2 className="treatment-section-title">{section.title}</h2> {/* Заголовок секции */}

                        <div className="treatment-cards-list"> {/* Контейнер для списка карточек */}
                            {section.items.map((item, itemIndex) => (
                                <div className="treatment-card" key={itemIndex}> {/* Карточка Процедуры/Программы */}
                                    <div className="treatment-card-content"> {/* Контентная часть карточки */}
                                        {/* Баннер с названием программы/процедуры */}
                                        <div className="treatment-card-banner">
                                            {item.title}
                                        </div>
                                        <h3 className="treatment-item-title">{item.title}</h3> {/* Название Процедуры/Программы */}
                                        <p className="treatment-item-description">{item.description}</p> {/* Описание */}
                                        {/* Кнопка или ссылка "О ПРОГРАММЕ" - УДАЛЕНА */}
                                        {/* <a href={item.link || "#"} className="treatment-details-link">О ПРОГРАММЕ</a> */}
                                    </div>
                                    <div className="treatment-card-image-container"> {/* Контейнер для картинки */}
                                        {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="treatment-card-image"/>} {/* Картинка */}
                                    </div>
                                </div>
                                ))}
                        </div>
                    </section>
                    ))}
            </div> {/* Конец .sections-wrapper */}

        </div> // Конец .treatment-page-container
    );
};

export default TreatmentPage;